import {makeStyles} from "@material-ui/core";

export default function Styles() {
    return makeStyles(theme => ({
        typography: {
            textAlign: 'center'
        },
        searchField: {
            width: "100%",
            marginTop: '2%',
            marginBottom: '2%',
        },
        footer: {
            marginTop: '4%'
        },
        bt_footers: {
            textAlign: 'right'
        }
    }));
};
